import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../../lib/ep';

import ActionLink from '../../builder/ActionLink';

import MyNetworks from '../MyNetworks';

const NetworksButton = (props) => {
	const [ display_layer, setDisplayLayer ] = useState(false);
	const promotion = props?.promotion ?? false;
	if(promotion === false) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = props?.is_builder ?? false;
	const use_react = window?.use_react ?? true;
	
	let default_layer_title = i18n("Follow us");
	if(isNotEmpty(promotion.my_networks.sections[0], 'text')) default_layer_title = promotion.my_networks.sections[0].text;

	const label = props?.children ?? i18n("Follow us");

	const icon = props?.icon ?? 'knk-networks';

	const section = props.promotion?.my_networks?.sections[0] ?? {};

	const networks = section?.nets;
	if (networks == undefined) return null;
	

	return (
		<>
			<ActionLink
				icon={icon}
				_class={{ other:'networks_btn' }}
				data_attr={(!use_react && !is_builder) ? { 'data-contextual_box':`{ "label":"<h1>${default_layer_title}</h1>", "c_data":{ "template_id":"follow_us", "handler":"EP.mynets.display", "after":"EP.mynets.netsSetup_", "pid":${promotion.id} }, "full_content":1, "display_footer_buttons":1 }` } : null}
				onClick={(use_react && !is_builder) ? () => setDisplayLayer(true) : null}
			>{label}</ActionLink>

			{(display_layer) && (
				<MyNetworks
					promotion={promotion}
					close={() => setDisplayLayer(false)}
				/>
			)}
		</>
	)
};

export default injectIntl(NetworksButton);